import {BaseModel} from '../base/BaseModel';

/**
 * @class CropUsageModel
 * @extends BaseModel
 *
 * @property {object} attributes
 */
export class CropUsageModel extends BaseModel {

    initialize () {

        this.microservice = 'md2';
        this.resource = 'crop-usages';
    }

    get defaults () {

        return {
            uuid: undefined,
            code: undefined,
            name: undefined,
            description: undefined,
        };
    }
}


// WEBPACK FOOTER //
// ./shared/model/md2/CropUsageModel.js